import { render } from "./ItemListaSelecionada.vue?vue&type=template&id=7ad5179e"
import script from "./ItemListaSelecionada.vue?vue&type=script&lang=js"
export * from "./ItemListaSelecionada.vue?vue&type=script&lang=js"

import "./ItemListaSelecionada.vue?vue&type=style&index=0&id=7ad5179e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__